import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useActiveDocument, useCompanyLogo, usePleditor } from 'shared/domains/documents';
export function DownloadPleditorDocxItem(props) {
    const { disabled, onDownload } = props;
    const { pleditor, pleditorState } = usePleditor();
    const { name: documentName } = useActiveDocument();
    const companyLogo = useCompanyLogo();
    const handleDownload = () => {
        if (!pleditor) {
            return;
        }
        const exportConverterUrl = process.env.PLEDITOR_EXPORT_CONVERTER_URL;
        const header = {
            css: `img.company-logo { max-height: ${companyLogo.height}; }`,
            html: `<img class="company-logo" src="${companyLogo.url}" />`,
        };
        pleditor.commands.execute('exportWord', {
            fileName: `${documentName}.docx`,
            converterUrl: exportConverterUrl,
            version: 2,
            stylesheets: ['../../public/docx.css'],
            converterOptions: {
                headers: {
                    first: companyLogo.url ? header : undefined,
                },
            },
        });
        onDownload();
    };
    return (<Menu.Item disabled={pleditorState !== 'initialized' || disabled} onClick={handleDownload}>
      <Falcon icon="file-word"/>
      <Menu.ItemText primary={t({ message: 'Download DOCX', comment: 'Download DOCX label' })}/>
    </Menu.Item>);
}
